import React, { useState, useEffect } from 'react'
import * as signalR from "@microsoft/signalr";
import 'leaflet/dist/leaflet.css';
import './Nav.css'


function MsgBox({imei, showMsgs, startMsgs}) {
    const protocol = new signalR.JsonHubProtocol();
    const [hub, setHub] = useState(hubConnect);
    const [statusText, setStatusText] = useState(startMsgs);

    useEffect(() => {
        return () => {
            hub.stop();
            //console.log("msg-box unmount");
        };
    }, []);

    useEffect(() => {
        //console.log('MsgBox: switch imei')
    }, [imei]);

    useEffect(() => {
        console.log('setStartMsgs:');
        console.log(startMsgs);
        //setStatusText(startMsgs);
        
    }, [startMsgs]);


    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();

        connection.onreconnecting((error) => {
            console.log("hub status text reconnect");
        });
        connection.on('StatusText', (message) =>
        {
            setStatusText((prevText) => {
                const filtered = prevText.filter((msg) => msg.imei !== message.imei);
                const sameImei = prevText.filter((msg) => msg.imei === message.imei);
            
                return [...filtered, ...sameImei.slice(-2), message];
              });
        });
        connection.start();
        return connection;
    }

    function getClassColor(severity){
        if(severity === null)
            return 'addition-white'

        if(severity <= 2)
            return 'addition-red'

        if(severity <= 4)
            return 'addition-yell'
    }

    return(
        <div className={'tel-box msg-box ' + getClassColor(statusText.findLast((t) => t.imei === imei)?.severity)} onClick={showMsgs}>{statusText.findLast((t) => t.imei === imei)?.message}</div>
    )
}

export default MsgBox;